import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconWrapper,
  ArticleImage,
  ArticleInformation,
  CarouseLWrapper,
  BottomSection,
  ModuleWrapper,
} from './Mandarin.styled';
import { Body6, Headline3 } from './../../../app/common/typography';

const Card = ({ itemData, cardNavigatePath, showScores }) => {
  const navigate = useNavigate();
  return (
    <IconWrapper
      onClick={() => {
        navigate(`${cardNavigatePath}/${itemData.id}`);
      }}
    >
      <ArticleImage>
        <img src={itemData.pictureUrl} />
      </ArticleImage>
      <BottomSection>
        <ArticleInformation>
          <Body6 color="eerieBlack">{itemData.label}</Body6>
        </ArticleInformation>
      </BottomSection>
    </IconWrapper>
  );
};

const CardViewer = ({ data, cardNavigatePath, showScores = false }) => {
  const modules = data.modules;
  return (
    <CarouseLWrapper>
      <Headline3 color="eerieBlack">
        {data.name} ({modules.length})
      </Headline3>
      <ModuleWrapper>
        {modules.map((item, i) => {
          const module = data.name;
          const suggestions = [
            modules[(i + 1) % modules.length],
            modules[(i + 2) % modules.length],
          ];
          return (
            // tslint:disable-next-line:jsx-key
            <Card
              itemData={{ ...item, module, suggestions }}
              cardNavigatePath={cardNavigatePath}
              showScores={showScores}
            />
          );
        })}
      </ModuleWrapper>
    </CarouseLWrapper>
  );
};

export default CardViewer;
